import { newRelicJSError } from './analytics/new_relic_helper';
import {APP_NAME, APP_VERSION} from '../constants/default.constants';
import OptimizelyHelper from './optimizely_helper';

export function dtmLoaded() {
    try {
        _satellite.setVar('app-name', APP_NAME);
        _satellite.setVar('app-version', APP_VERSION);

        if (window.optimizely) {
          const optimizelyHelper = new OptimizelyHelper();
          optimizelyHelper.sendActiveExperimentsToAdobe();
          optimizelyHelper.sendVariationsToAdobe();
        }
    } catch (err) {
        const error = 'Error firing DTM loaded: ' + err;
        newRelicJSError(error);
        console.error(error);
    }
}

export function directCall(directCallRule, dataElements = {}) {
  try {
    if (typeof dataElements !== 'object') {
      console.error('dataElements needs to be an object.');
      return;
    }
    _satellite.setVar('app-name', APP_NAME);
    _satellite.setVar('app-version', APP_VERSION);
    Object.keys(dataElements).forEach(function (key) { // setVar on all dataElements before we track the directCallRule
      _satellite.setVar(key, dataElements[key]);
    })
    _satellite.track(directCallRule);
  } catch (err) {
    const error = 'Error firing DTM Direct Call Rule: ' + err;
    newRelicJSError(error);
    console.error(error);
  }
}

export function getSCVisitorId() {
    let scVisitorId = undefined;

    // Use the built in function
    if(window._satellite) {
        scVisitorId = _satellite.getVisitorId();
    }

    // Otherwise search the user's cookies
    if(!scVisitorId) {
        let parsedCookie = document.cookie
       .replace(/(?:(?:^|.*;\s*)s_vi\s*\=\s*([^;]*).*$)|^.*$/, '$1')
       .match(/(?!.*(\|)).*(?=(\[.*))/);

       if (parsedCookie && parsedCookie.length > 0) {
           scVisitorId = parsedCookie[0];
       }
    }

    return scVisitorId || '';
}

export function sharedCall(actionKey, actionType, actionValues = 'Completed') {
    directCall('shared-call', {
        'action-type': actionType,
        'action-keys': actionKey,
        'action-values': actionValues
    });
}


export function track(actionKey, actionType, actionValues) {
	directCall('shared-call', {
		'action-type': actionType,
		'action-keys': actionKey,
		'action-values': actionValues || 'Completed'
	});
}
